<template>

	<div v-if = "!Login.username" class="login_box">

		<span>余米登录平台</span>
		<input v-model="loginForm.username" placeholder="请输入账号" />
		<input v-model="loginForm.password" type="password" placeholder="请输入密码" />
		<div class="vertify">
			<input v-model="loginForm.code" placeholder="请输入验证码" /><img @click="reflushCode" :src="imgData" />
		</div>
		<div class='login_button' @click="loginAction">登录</div>
		<div class='login_type'>
			<span>企业注册</span>
			<span>个人注册</span>
		</div>
	</div>
	<div v-else class="login_box">
		 <el-image
		      style="width: 100px; height: 100px"
		      :src="Login.avatar"
		      fit="fill"></el-image>
		<p>欢迎登录</p>
	</div>
</template>

<script>
	import {
		getCodeImg,
		login
	} from '../../api/login.js'
	import {setToken} from '../../utils/auth.js'
import {mapGetters} from 'vuex'
	export default {
		computed:{
	...mapGetters(['Login'])
},
		data() {

			return {
				imgData: "",
				loginForm: {

					username: "",
					password: "",
					code: "",
					uuid: ""

				}
			}

		},
		created() {
			console.log('[loginref this.Login]',this.Login);
			if(!this.Login.username){
				this.$nextTick(()=>{
					this.reflushCode()
				})
				
			}
			
			

		},

		methods: {

			reflushCode() {
				getCodeImg().then(res => {
					this.imgData = "data:image/png;base64," + res.img
					this.loginForm.uuid = res.uuid
				})
			},
			loginAction() {                                                                                                                           
				login(this.loginForm.username, this.loginForm.password, this.loginForm.code, this.loginForm.uuid).then(res => {
					setToken(res.token)
					this.$store.dispatch("Login",res.user)
					 this.$notify({
							  type: 'success',
					          title: '提示',
					          message: '登录成功',
					          duration: 2000
					  });
				})
			}
		}

	}
</script>

<style>
	.login_box {
		width: 16vw;
		height: 19.06vw;
		background-color: #ffffff;
		box-shadow: 0vw 0.42vw 1.42vw 0.09vw rgba(229, 229, 229, 0.5);
		border: solid 0.05vw #ddd7d7;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
	}

	.login_box>span:nth-child(1) {
		font-weight: 800;
		width: 7vw;
		height: 1.15vw;
		font-family: PingFangSC-Medium;
		font-size: 1.15vw;

		line-height: 1.38vw;
		letter-spacing: 0vw;
		color: #171717;


	}

	.login_box input:nth-child(2) {
		width: 14.11vw;
		height: 2.24vw;
		background-color: #f5f5f5;
		border: none;
	}

	.login_box input:nth-child(3) {
		width: 14.11vw;
		height: 2.24vw;
		background-color: #f5f5f5;
		border: none;
	}

	.vertify {

		display: flex;
		width: 14.11vw;

	}

	.vertify img {
		width: 4.74vw;
		height: 2.19vw;

	}

	.vertify input {
		width: 9.17vw;
		height: 2.24vw;
		background-color: #f5f5f5;
		border: none;
	}

	.login_type {
		width: 9.4vw;
		display: flex;
		justify-content: space-between;
	}

	.login_type span {
		width: 4vw;
		height: 0.83vw;
		font-family: SourceHanSansCN-Regular;
		font-size: 0.83vw;
		font-weight: normal;
		font-stretch: normal;
		line-height: 1.04vw;
		letter-spacing: 0vw;
		color: #5a5a5a;

	}

	.login_button {

		width: 14.11vw;
		height: 2.24vw;
		background-image: linear-gradient(259deg,
			#527ef8 0%,
			#495bea 43%,
			#4037dc 100%),
			linear-gradient(#337df7,
			#337df7);
		background-blend-mode: normal,
			normal;
		border-radius: 0.21vw;
		line-height: 2.24vw;
		text-align: center;
		color: #FFFFFF;

	}
</style>
